import React from 'react';
import ReactDOM from 'react-dom';
import mixin from 'react-mixin';

const RealizeButton = window.Button;
const RealizeTooltipMixin = window.TooltipMixin;

@mixin.decorate(RealizeTooltipMixin)
export default class Button extends RealizeButton {

	parseButtonProps(buttonProps) {
		return Object.assign({}, buttonProps, this.tooltipAttributes(), {
			id: this.props.id,
			ref: 'button',
			className: this.getButtonClassName(),
			href: this.getButtonHref(),
			onClick: this.handleTooltipedButtonClick.bind(this),
			onKeyDown: this.handleOnKeyDown.bind(this),
			style: this.props.cssStyle,
			'data-tooltip': Realize.i18n.t(this.props.tooltipText),
			'aria-label': this.props['aria-label'],
			role: this.props['role'],
			tabIndex: 0
		});
	}

	handleOnKeyDown(e) {
		if(e.key === 'Enter' && e.currentTarget.tagName !== "BUTTON") {			
            e.currentTarget.click();
		}
	}

	getButtonClassName() {
		let className = this.className();
		if (this.props.disabled && this.props.element === 'button')
			className += ' disabled-button';
		if(!!this.props.tooltipText)
			className += ' tooltipped';

			className += this.getVisibility();

		return className;
	}

	getVisibility(){
		if(this.props.visibility !== null && this.props.visibility !== undefined) return " "+this.props.visibility;
		return "";
	}

	getButtonHref() {
		if (this.props.disabled && this.props.element === 'button')
			return null;
		return this.props.href;
	}

	handleTooltipedButtonClick(event) {
		$(ReactDOM.findDOMNode(this.refs.button)).trigger('mouseleave');
		if(this.props.disabled) {
			return;
		}

		let buttonOnClick = this.props.onClick;
		let buttonAction = this.props.actionUrl;

		if(typeof buttonOnClick == "function") {
			this.props.onClick(event);
		} else if(!!buttonAction) {
			let actionData = this.props.actionData;
			this.performRequest(buttonAction, actionData, (this.getMethod() || 'POST'));
		}
	}

	componentWillReceiveProps(newProps) {
		const { style } = newProps;
		if(style) {
			this.setState({
				themeClassKey: `${this.getButtonThemeClassKey()} button.${style}`,
			});
		}
	}

	render() {
		const button = super.render();
		return React.createElement(
			this.props.element,
			this.parseButtonProps(button.props),
			button.props.children
		);
	}

	renderIconCustom() {
		if(!this.props.icon) {
			return '';
		}

		var iconProps = null;
		if($.isPlainObject(this.props.icon)) {
			iconProps = { ...this.props.icon, 'aria-hidden': true };
		} else {
			iconProps = { type: this.props.icon, 'aria-hidden': true };
		}
		
		return <Icon className={this.getIconClassName()} {...iconProps} key="icon" />;
	}

	renderContentCustom() {
		return [Realize.i18n.t(this.props.name), this.renderIconCustom()];
	}

	render() {
		var content = '';
		if(this.props.isLoading) {
		  content = this.renderLoadingIndicator();
		} else {
		  content = this.renderContentCustom();
		}

		const button = super.render();
		return React.createElement(
			this.props.element,
			this.parseButtonProps(button.props),
			content
		);
	  }

}